import { render, staticRenderFns } from "./Rendicontazione.vue?vue&type=template&id=ea8ab59a&"
import script from "./Rendicontazione.vue?vue&type=script&lang=js&"
export * from "./Rendicontazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports